import { Rating, Stack, Typography } from 'core/common/ui/ui-kit';
import { getInitials } from 'core/common/utils/getInitials';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { NebReviewCard } from 'core/flow/entities';
import { AvatarFallbackStyled, AvatarStyled, CardWrapperStyled } from './styled';

type ReviewCardProps = {
  content: NebReviewCard;
};

export const ReviewCard = ({ content }: ReviewCardProps) => {
  const { user, date, review } = content;

  return (
    <CardWrapperStyled>
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={3}>
        <Stack direction="row" alignItems="center" gap={3}>
          {user.avatar ? (
            <AvatarStyled src={user.avatar.src} alt={user.avatar.alt} width={36} height={36} />
          ) : (
            <AvatarFallbackStyled>
              <Typography variant="text-body-xs-bold">{getInitials(user.name)}</Typography>
            </AvatarFallbackStyled>
          )}
          <Stack gap="2px">
            <Typography
              variant="text-heading-xs"
              dangerouslySetInnerHTML={prepareHtml(user.name)}
            />
            <Typography
              color="text.secondary"
              variant="text-body-2xs"
              dangerouslySetInnerHTML={prepareHtml(date)}
            />
          </Stack>
        </Stack>
        <Rating value={5} readOnly size="small" />
      </Stack>
      <Typography variant="text-body-sm" dangerouslySetInnerHTML={prepareHtml(review)} />
    </CardWrapperStyled>
  );
};
